/**
 * Whether the password-reset form has to carry a captcha token.
 *
 * NOT the brand's `captcha.enabled` switch, which governs login and register.
 * svc-auth requires a captcha on reset-with-bank-account whenever the platform
 * has a captcha provider at all, so that a brand cannot switch off the only bot
 * control on the one unauthenticated password-changing endpoint. The site key is
 * the only sign of a provider this app receives; reading the brand switch here
 * left every brand with the switch off unable to reset a password (401
 * CAPTCHA-002, with no widget on the page to solve). Where no provider is
 * configured the token is ignored.
 */
export function resetNeedsCaptcha(
  captcha: { enabled?: boolean; siteKey?: string | null } | undefined,
): boolean {
  return Boolean(captcha?.siteKey);
}
